// extracted by mini-css-extract-plugin
export default {"logo_ecoideas":"Navbar_logo_ecoideas__nDV+z"};